
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 9.778c0-.254-.336-.266-.547-.125-1.261.851-4.57 1.458-8.453 1.458-3.883 0-7.191-.607-8.454-1.458-.21-.141-.546-.129-.546.125C3 11.005 7.03 12 12 12s9-.995 9-2.222zM15.273 6.844c0 .392-1.466.712-3.273.712-1.803 0-3.266-.317-3.273-.709v-.003C8.727 5.274 10.193 4 12 4c1.807 0 3.272 1.273 3.273 2.844z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.09 6.855v.006c-.004.363-.178.62-.312.762a1.51 1.51 0 01-.413.302c-.253.13-.568.224-.89.294-.66.143-1.534.225-2.475.225-.939 0-1.811-.081-2.47-.224a3.76 3.76 0 01-.89-.292 1.522 1.522 0 01-.411-.297 1.133 1.133 0 01-.32-.767v-.02c0-.408-.334-.783-.738-.72C4.663 6.52 3 7.211 3 8c0 1.227 4.03 2.222 9 2.222S21 9.227 21 8c0-.789-1.664-1.481-4.172-1.876-.403-.063-.737.311-.737.72v.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.481 5.863c.376.027.717.268.769.642a2.5 2.5 0 01.023.339c0 .392-1.466.712-3.273.712-1.803 0-3.266-.317-3.273-.709v-.003c0-.115.008-.228.023-.34.052-.373.393-.614.769-.64.788-.056 1.62-.086 2.481-.086.86 0 1.693.03 2.481.085z","fill":"currentColor"}})])
          )
        }
      }
    